<!--
<nav class="navbar navbar-expand-xl navbar-light bg-light">
    <div style="display: flex; flex-grow: 1;">
        <div class="navbar-brand">
          <img src="../assets//img/2000px-Vodafone_icon.svg.png"
        alt="Vodafone"
        style="height: 60px;margin-right: 10px;cursor: pointer;"
        (click)="goToHome()">
        VMS
        </div>

        <div class="collapse navbar-collapse" id="navbarTogglerDemo02"
                [ngbCollapse]="isCollapsed">
          <ul class="navbar-nav mt-2 mt-lg-0 ml-auto" id="unSortedLst1">

            <li class="nav-item">
              <a  class="nav-link" routerLink="/home"  routerLinkActive='active' mat-menu-item style="text-align: center">
                <span class="font-boldfont-weight-bold text-uppercase">Home</span>
              </a>
            </li>

            <li class="nav-item">
              <button class="nav-link" [matMenuTriggerFor]="systemsprofile" mat-menu-item style="text-align: center">
                <span class="font-boldfont-weight-bold text-uppercase">Systems Profile</span>
                <mat-icon aria-hidden="false" aria-label="Example home icon">expand_more</mat-icon>
              </button>
            </li>

            <li class="nav-item" *ngIf='adminAuthorization'>
              <button class="nav-link" [matMenuTriggerFor]="ConfigurationManagement" mat-menu-item style="text-align: center">
                <span class="font-boldfont-weight-bold text-uppercase">Configuration Management</span>
                <mat-icon aria-hidden="false" aria-label="Example home icon">expand_more</mat-icon>
              </button>
            </li>

            <li class="nav-item" *ngIf='adminAuthorization'>
              <button class="nav-link" [matMenuTriggerFor]="SoftwareManager" mat-menu-item style="text-align: center">
                <span class="font-boldfont-weight-bold text-uppercase">Software Management</span>
                <mat-icon aria-hidden="false" aria-label="Example home icon">expand_more</mat-icon>
              </button>
            </li>


            <li class="nav-item" *ngIf='adminAuthorization'>
              <a  class="nav-link" routerLink="/logs"  routerLinkActive='active' mat-menu-item style="text-align: center">
                <span class="font-boldfont-weight-bold text-uppercase">Logs</span>
              </a>
            </li>

            <li class="nav-item" *ngIf='adminAuthorization'>

              <button class="nav-link" [matMenuTriggerFor]="Admin" mat-menu-item style="text-align: center">
                <span class="font-boldfont-weight-bold text-uppercase">Admin</span>
                <mat-icon aria-hidden="false" aria-label="Example home icon">expand_more</mat-icon>
              </button>
            </li>
          </ul>

          <div class="d-flex ml-auto">
              <div class="ml-auto">
                <a class="nav-link " (click)="openDialog()" style="padding: 0.1rem 0.5rem !important;">
                  <mat-icon style="font-size: 22px; width:  22px;margin-right: 0px !important;" id='icon'>manage_search</mat-icon>
                </a>
              </div>

              <div class="mr-auto">
                <a class="nav-link" [matMenuTriggerFor]="userMenu" style="padding: 0.3rem 0.5rem !important;">
                  <i class="fa fa-user" aria-hidden="true"id='icon'></i>
                </a>
              </div>
          </div>

        </div>

        <button class="navbar-toggler btn btn-outline-primary ml-auto"
        style=" color: black;"
        type="button" data-toggle="collapse" aria-expanded="false"
        data-target="#navbarTogglerDemo02"  aria-label="Toggle navigation"
        (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
        aria-controls="navbarTogglerDemo02" >
        <span class="navbar-toggler-icon"></span>
        </button>

    </div>
</nav>


<mat-menu #menu="matMenu" style="width:900px;">
  <h5>VMS Navigation Menu</h5>
  <button routerLink="/home"  mat-menu-item>
    <i class="fa fa-home text-danger mr-1 "></i>
    <span>Home</span>
  </button>


  <button routerLink="/admin" *ngIf='adminAuthorization'  mat-menu-item>
    <i class="fa fa-server text-danger mr-1"></i>
    <span>Administrator Page</span>
  </button>

  <button [matMenuTriggerFor]="systemsprofile" mat-menu-item>
    <i class="fa fa-sitemap text-danger mr-1"></i>
    <span>Systems Profile</span>
  </button>

  <button [matMenuTriggerFor]="ConfigurationManagement" mat-menu-item>
    <i class="fa fa-cog text-danger mr-1"></i>
    <span>Configuration Management</span>
  </button>

  <button [matMenuTriggerFor]="SoftwareManager" mat-menu-item>
    <i class="fa fa-wrench text-danger mr-1"></i>
    <span>Software Management</span>
  </button>


  <button routerLink="/logs" *ngIf='adminAuthorization'  mat-menu-item>
    <mat-icon class="text-danger mr-1" style="font-size: 18px; width:  18px;">auto_stories</mat-icon>
    <span>Logs</span>
  </button>

</mat-menu>

<mat-menu #systemsprofile="matMenu">
  <a  routerLink="/systemprofile" routerLinkActive='active' class='nav-link' mat-menu-item>
    <i class="fa fa-list-alt text-danger mr-1"></i>
    <span>Systems Profile</span>
  </a>


  <a routerLink="/foldermanager" mat-menu-item *ngIf='adminAuthorization'>
    <i class="fa fa-folder text-danger mr-1"></i>
    <span>Folders Management</span>
  </a>

  <a routerLink="/reportgenerator"  mat-menu-item *ngIf='adminAuthorization'>
  <i class="fa fa-table text-danger mr-1"></i>
  <span>System Reports</span>
  </a>

</mat-menu>

<mat-menu #ConfigurationManagement="matMenu">
  <a routerLink="/templatemanager" mat-menu-item>
    <i class="fa fa-cubes text-danger mr-1"></i>
    <span>System Templates</span>
  </a>
</mat-menu>
<mat-menu #SoftwareManager="matMenu">
  <a routerLink="/softwareupdate" mat-menu-item>
    <i class="fa fa-arrow-circle-up text-danger mr-1"></i>
    <span>System Software Manager</span>
  </a>
  <a routerLink="/packagemanager" mat-menu-item>
    <i class="fa fa-box-open text-danger mr-1"></i>
    <span>Package Manager</span>
  </a>
</mat-menu>

<mat-menu #Admin="matMenu">
  <a routerLink="/admin" mat-menu-item>
    <i class="fa fa-users text-danger mr-1"></i>
    <span>Users Manager</span>
  </a>
  <a routerLink="/marketlocation" mat-menu-item>
    <i class="fa fa-globe text-danger mr-1"></i>
    <span>System Market Manager</span>
  </a>
</mat-menu>


<mat-menu #userMenu="matMenu">

    <h2>
      <mat-icon aria-hidden="false" aria-label="Example home icon" style="font-size: 1.5em;position: relative;right:20px;top:10px;">account_circle</mat-icon>
        <span>{{user_info_obj?.displayname}}</span>
    </h2>


  <button (click)="openConfirmationDialog()"  mat-menu-item>
    <mat-icon aria-hidden="false" aria-label="Example home icon">report_problem</mat-icon>

    <span>Report an issue</span>
  </button>

</mat-menu> -->





<!-- this is the old code -->






<nav class="navbar navbar-expand-xl navbar-light bg-light">
  <div style="display: flex; flex-grow: 1;">
      <div class="navbar-brand">
        <img src="../assets//img/2000px-Vodafone_icon.svg.png"
      alt="Vodafone"
      style="height: 60px;margin-right: 10px;cursor: pointer;"
      (click)="goToHome()">
      VMS
      </div>

      <div class="collapse navbar-collapse" id="navbarTogglerDemo02"
              [ngbCollapse]="isCollapsed">
        <ul class="navbar-nav mt-2 mt-lg-0 ml-auto" id="unSortedLst1">

          <li class="nav-item">
            <a  class="nav-link" routerLink="/home"  routerLinkActive='active' mat-menu-item style="text-align: center">
              <span class="font-boldfont-weight-bold text-uppercase">Home</span>
            </a>
          </li>

          <li class="nav-item">
            <button class="nav-link" [matMenuTriggerFor]="systemsprofile" mat-menu-item style="text-align: center">
              <span class="font-boldfont-weight-bold text-uppercase">Systems Profile</span>
              <mat-icon aria-hidden="false" aria-label="Example home icon">expand_more</mat-icon>
            </button>
          </li>

          <li class="nav-item" *ngIf='adminAuthorization'>
            <button class="nav-link" [matMenuTriggerFor]="ConfigurationManagement" mat-menu-item style="text-align: center">
              <span class="font-boldfont-weight-bold text-uppercase">Configuration Management</span>
              <mat-icon aria-hidden="false" aria-label="Example home icon">expand_more</mat-icon>
            </button>
          </li>

          <li class="nav-item" *ngIf='adminAuthorization'>
            <button class="nav-link" [matMenuTriggerFor]="SoftwareManager" mat-menu-item style="text-align: center">
              <span class="font-boldfont-weight-bold text-uppercase">Software Management</span>
              <mat-icon aria-hidden="false" aria-label="Example home icon">expand_more</mat-icon>
            </button>
          </li>

          <!-- <li class="nav-item">
            <a  class="nav-link" routerLink="/phonebook"  routerLinkActive='active' mat-menu-item style="text-align: center">
              <span class="font-boldfont-weight-bold text-uppercase">Address book</span>
            </a>
          </li> -->

          <li class="nav-item" *ngIf='adminAuthorization'>
            <a  class="nav-link" routerLink="/logs"  routerLinkActive='active' mat-menu-item style="text-align: center">
              <span class="font-boldfont-weight-bold text-uppercase">Logs</span>
            </a>
          </li>

          <!-- <li class="nav-item" *ngIf='adminAuthorization'>
            <a  class="nav-link" routerLink="/reportgenerator"  routerLinkActive='active' mat-menu-item style="text-align: center">
              <span class="font-boldfont-weight-bold text-uppercase">System Reports</span>
            </a>
          </li> -->

          <li class="nav-item" *ngIf='adminAuthorization'>
            <!-- <a  class="nav-link" routerLink="/admin"  routerLinkActive='active' mat-menu-item style="text-align: center">
            <a  class="nav-link" routerLink="/reportgenerator"  routerLinkActive='active' mat-menu-item style="text-align: center">
              <span class="font-boldfont-weight-bold text-uppercase">System Reports</span>
            </a>
          </li>

          <li class="nav-item" *ngIf='adminAuthorization'>
            <a  class="nav-link" routerLink="/admin"  routerLinkActive='active' mat-menu-item style="text-align: center">
              <span class="font-boldfont-weight-bold text-uppercase">Admin</span>
            </a> -->
            <button class="nav-link" [matMenuTriggerFor]="Admin" mat-menu-item style="text-align: center">
              <span class="font-boldfont-weight-bold text-uppercase">Admin</span>
              <mat-icon aria-hidden="false" aria-label="Example home icon">expand_more</mat-icon>
            </button>
          </li>
        </ul>

        <div class="d-flex ml-auto">
            <div class="ml-auto">
              <a class="nav-link " (click)="openDialog()" style="padding: 0.1rem 0.5rem !important;">
                <mat-icon style="font-size: 22px; width:  22px;margin-right: 0px !important;" id='icon'>manage_search</mat-icon>
              </a>
            </div>

            <div class="mr-auto">
              <a class="nav-link" [matMenuTriggerFor]="userMenu" style="padding: 0.3rem 0.5rem !important;">
                <i class="fa fa-user" aria-hidden="true"id='icon'></i>
              </a>
            </div>
        </div>

      </div>

      <button class="navbar-toggler btn btn-outline-primary ml-auto"
      style=" color: black;"
      type="button" data-toggle="collapse" aria-expanded="false"
      data-target="#navbarTogglerDemo02"  aria-label="Toggle navigation"
      (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
      aria-controls="navbarTogglerDemo02" >
      <span class="navbar-toggler-icon"></span>
      </button>

    </div>
</nav>





<!-- <div class="row">
<img src="../assets//img/2000px-Vodafone_icon.svg.png"
 alt="Vodafone"
 style="height: 60px;margin-right: 10px;cursor: pointer;"
 (click)="goToHome()">
<button [matMenuTriggerFor]="menu" mat-fab color="primary" class=" navbarcustom"
        aria-label="Example icon button with a delete icon">
  <mat-icon>menu</mat-icon>
  <span>VMS</span>
</button>
<button mat-fab color="primary" class="float-right-searchbar-div mr-4" (click)="openSearchDialog()">
  <i class="fa fa-search" aria-hidden="true"></i>
</button>
<button [matMenuTriggerFor]="userMenu" mat-fab color="primary" class="float-right-navbar-div mr-2">
  <i class="fa fa-user" aria-hidden="true"></i>
</button>

</div> -->


<mat-menu #menu="matMenu" style="width:900px;">
<h5>VMS Navigation Menu</h5>
<button routerLink="/home"  mat-menu-item>
  <i class="fa fa-home text-danger mr-1 "></i>
  <span>Home</span>
</button>


<button routerLink="/admin" *ngIf='adminAuthorization'  mat-menu-item>
  <i class="fa fa-server text-danger mr-1"></i>
  <span>Administrator Page</span>
</button>

<button [matMenuTriggerFor]="systemsprofile" mat-menu-item>
  <i class="fa fa-sitemap text-danger mr-1"></i>
  <span>Systems Profile</span>
</button>

<button [matMenuTriggerFor]="ConfigurationManagement" mat-menu-item>
  <i class="fa fa-cog text-danger mr-1"></i>
  <span>Configuration Management</span>
</button>

<button [matMenuTriggerFor]="SoftwareManager" mat-menu-item>
  <i class="fa fa-wrench text-danger mr-1"></i>
  <span>Software Management</span>
</button>

<!-- <button routerLink="/phonebook" mat-menu-item>
  <i class="fa fa-address-book text-danger mr-1"></i>
  <span>Address book</span>
</button> -->

<button routerLink="/logs" *ngIf='adminAuthorization'  mat-menu-item>
  <mat-icon class="text-danger mr-1" style="font-size: 18px; width:  18px;">auto_stories</mat-icon>
  <span>Logs</span>
</button>

</mat-menu>

<mat-menu #systemsprofile="matMenu">
<a  routerLink="/systemprofile" routerLinkActive='active' class='nav-link' mat-menu-item>
  <i class="fa fa-list-alt text-danger mr-1"></i>
  <span>Systems Profile</span>
</a>


<a routerLink="/foldermanager" mat-menu-item *ngIf='adminAuthorization'>
  <i class="fa fa-folder text-danger mr-1"></i>
  <span>Folders Management</span>
</a>

<a routerLink="/reportgenerator"  mat-menu-item *ngIf='adminAuthorization'>
  <i class="fa fa-table text-danger mr-1"></i>
  <span>System Reports</span>
</a>

</mat-menu>

<mat-menu #ConfigurationManagement="matMenu">
<a routerLink="/templatemanager" mat-menu-item>
  <i class="fa fa-cubes text-danger mr-1"></i>
  <span>System Templates</span>
</a>
</mat-menu>
<mat-menu #SoftwareManager="matMenu">
<a routerLink="/softwareupdate" mat-menu-item>
  <i class="fa fa-arrow-circle-up text-danger mr-1"></i>
  <span>System Software Manager</span>
</a>
<a routerLink="/packagemanager" mat-menu-item>
  <i class="fa fa-box-open text-danger mr-1"></i>
  <span>Package Manager</span>
</a>
</mat-menu>

<mat-menu #Admin="matMenu">

  <a routerLink="/admin" mat-menu-item>
    <i class="fa fa-users text-danger mr-1"></i>
    <span>Users Manager</span>
  </a>

  <a routerLink="/marketlocation" mat-menu-item>
    <i class="fa fa-globe text-danger mr-1"></i>
    <span>System Market Manager</span>
  </a>
  
</mat-menu>


<mat-menu #userMenu="matMenu">

  <h2>
    <mat-icon aria-hidden="false" aria-label="Example home icon" style="font-size: 1.5em;position: relative;right:50px;top:10px;">account_circle</mat-icon>
      {{user_info_obj?.name}}
  </h2>

<button (click)="logOut()"  mat-menu-item>
  <mat-icon aria-hidden="false" aria-label="Example home icon">logout</mat-icon>

  <span>logout</span>
</button>

<button (click)="openResetPasswordDialog()"  mat-menu-item>
  <mat-icon aria-hidden="false" aria-label="Example home icon">lock_reset</mat-icon>

  <span>Reset My Password</span>
</button>

<button (click)="openConfirmationDialog()"  mat-menu-item>
  <mat-icon aria-hidden="false" aria-label="Example home icon">report_problem</mat-icon>

  <span>Report an issue</span>
</button>

</mat-menu>
